import { FOfferType } from './category';

export function getGeoPlaceholder(offerType: FOfferType): string {
  if ((offerType & FOfferType.Urban) !== 0) {
    return 'Город, адрес, метро, район, ж/д, шоссе или ЖК';
  }

  if ((offerType & FOfferType.Suburban) !== 0) {
    return 'Город, адрес, метро, район, ж/д или шоссе';
  }

  return 'Город, адрес, метро, район или шоссе';
}
